import {
  Card,
  CardBody,
  Divider,
  Flex,
  Icon,
  Image as CImage,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import RegistrationIcon from "@icons/RegistrationIcon";

interface CheckoutSuccessEventInfoCardProps {
  itemsCount: Record<string, number>;
  children?: React.ReactNode;
  imgSrc?: string;
  cardTitle: string;
}

const CheckoutSuccessEventInfoCard = ({
  itemsCount,
  children,
  imgSrc,
  cardTitle,
}: CheckoutSuccessEventInfoCardProps) => {
  return (
    <Card
      marginTop={4}
      direction={{ base: "column", lg: "row" }}
      maxW={{ base: "100%" }}
      overflow="hidden"
      size="md"
      backgroundColor={useColorModeValue("white", "transparent")}
      boxShadow={useColorModeValue(
        "0px 0px 50px rgba(0, 0, 0, 0.05)",
        "0px 0px 50px rgba(255, 255, 255, 0.05)"
      )}
    >
      {imgSrc && (
        <CImage
          maxW={{ base: "100%", lg: "284px" }}
          background="#000000"
          objectFit="contain"
          src={imgSrc}
          alt={cardTitle}
        />
      )}
      <CardBody minWidth={{ base: "100%", sm: "280px" }}>
        <Flex
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          flexWrap="wrap"
          maxWidth="100%"
          gap={3}
        >
          <Text fontSize="1.125rem" fontWeight="700" color="primary.500">
            {cardTitle}
          </Text>
        </Flex>

        <Flex
          direction="row"
          justifyContent="left"
          alignItems="center"
          gap="1rem"
          marginTop={2}
          marginLeft={1}
          width="100%"
        >
          <Icon
            as={RegistrationIcon}
            className="svg-primary flex-shrink-0"
            boxSize={5}
            fill={"transparent"}
            alt="ticket icon"
          />
          <Text
            whiteSpace="pre"
            fontSize="md"
            fontWeight="medium"
            color={useColorModeValue("", "neutral.10")}
          >
            {Object.keys(itemsCount)
              .map((name) => `${itemsCount[name]} x  ${name}`)
              .join(", ")}
          </Text>
        </Flex>

        <Divider borderColor="neutral.700" marginTop={4} />

        {children}
      </CardBody>
    </Card>
  );
};

export default CheckoutSuccessEventInfoCard;
